import $ from 'jquery';
export class CartDiscountCodeForm {
	/*cart;
	element;
	form;
	statusElement;
	codeInput;
	submitButton; */
	constructor(cart, element) {
		this.cart = cart;
		this.element = element;
		this.form = this.element.find('form'); 
		this.statusElement = this.element.find('.status');
		this.codeInput = this.form.find('input');
		this.submitButton = this.form.find('button');
		
		this.element.find('span.close').click(this.onCloseClicked.bind(this));
		this.form.submit(this.onSubmit.bind(this));
		this.codeInput.on('input', this.onCodeChange.bind(this));
	}

    resetStatusDisplay() {
        this.statusElement.removeClass('accepted invalid checking');
    }
	
	open() {
		this.resetStatusDisplay();
		this.element.css('display', 'block');
		this.codeInput.val('');
		this.codeInput.focus();
		this.submitButton.attr('disabled', true);
		this.codeInput.attr('disabled', false);
	}
	
	onCloseClicked(event) {
		event.preventDefault();
		this.element.css('display', 'none');
	}
	
	onCodeChange(event) {
        this.resetStatusDisplay();
		this.submitButton.attr('disabled', this.codeInput.val().length === 0);
	}
	
	onSubmit(event) {
		event.preventDefault();
		
		let code = this.codeInput.val();
		if (code.length === 0) {
			return;
		}
        this.resetStatusDisplay();

		this.statusElement.addClass('checking');
		
		this.submitButton.prop('disabled', true);
		this.codeInput.prop('disabled', true);
		this.cart.applyDiscountCode(code).then(res => this.onCodeReturned(res.accepted, res.applies))
	}
	
	onCodeReturned(valid, appliesToAnyProduct) {
        this.resetStatusDisplay();
		this.submitButton.prop('disabled', false);
		this.codeInput.prop('disabled', false);
		if (valid === true) {
            this.statusElement.addClass('accepted');
			this.element.css('display', 'none');
		} else {
			this.statusElement.addClass('invalid');
		}
		if (!appliesToAnyProduct) {

		}
	}
}